export const CURRENCY_EXCHANGES_SECTION_TITLE = '7. Купівля-продаж валюти';
export const CURRENCY_EXCHANGES_TABLE_ARIA_LABEL = 'Купівля-продаж валюти';
export const CURRENCY_EXCHANGES_ADD_BUTTON_LABEL = 'Додати операцію';

export const CURRENCY_EXCHANGES_TABLE_HEADERS = [
  'Банк',
  'Валюта продана',
  'Сума проданої валюти, тис. од.',
  'Валюта куплена',
  'Сума купленої валюти, тис. од.',
] as const;

export const CURRENCY_EXCHANGES_TABLE_COLUMN_WIDTHS = [
  '30%',
  '17.5%',
  '17.5%',
  '17.5%',
  '17.5%',
] as const;
